import React, {Component} from 'react';
import './FormField.css';
import Explanation from './Explanation';

/**
 * A row of {@link FormFieldList} that has a label + input field and optional explanation text.
 */
class FormField extends Component {
	render() {
		const {label, explanation, error, children} = this.props;
		
		return (
			<li className={`FormField ${error ? 'error' : ''}`}>
				<label>
					<span>{label}</span>
					{explanation ? (
						<div className="FormField-explained">
							{children}
							<Explanation>
								{explanation}
							</Explanation>
						</div>
					) : children}
					{error ? (
						<div className="FormField-error">{error}</div>
					) : undefined}
				</label>
			</li>
		);
	}
}

export default FormField;


// WEBPACK FOOTER //
// ./src/widgets/FormField.js